import { render, staticRenderFns } from "./SingleSelectPosition.vue?vue&type=template&id=822bf7f6&scoped=true&"
import script from "./SingleSelectPosition.vue?vue&type=script&lang=js&"
export * from "./SingleSelectPosition.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelectPosition.vue?vue&type=style&index=0&id=822bf7f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822bf7f6",
  null
  
)

export default component.exports